/**
 * @generated SignedSource<<310091537dd690f9db74f85d0e6949a9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SettingsViewQuery$variables = {
  id: string;
  isFieldSettings: boolean;
  isPersonalSettings: boolean;
  isWorkspaceSettings: boolean;
  tql: string;
  workspaceUuid: string;
};
export type SettingsViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FieldSettingsView" | "PersonalSettings" | "WorkspaceSettings">;
};
export type SettingsViewQuery = {
  response: SettingsViewQuery$data;
  variables: SettingsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isFieldSettings"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPersonalSettings"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isWorkspaceSettings"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tql"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v6 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUuid"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v10 = {
  "kind": "ScalarField",
  "name": "key"
},
v11 = {
  "kind": "ScalarField",
  "name": "__id"
},
v12 = {
  "kind": "ClientExtension",
  "selections": [
    (v11/*: any*/)
  ]
},
v13 = [
  {
    "concreteType": "OnboardingEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "Onboarding",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v8/*: any*/)
        ]
      }
    ]
  },
  (v12/*: any*/)
],
v14 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v15 = [
  (v14/*: any*/),
  (v7/*: any*/)
],
v16 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 200
  }
],
v17 = {
  "kind": "ScalarField",
  "name": "type"
},
v18 = {
  "kind": "ScalarField",
  "name": "canSetMultipleValues"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SettingsViewQuery",
    "selections": [
      {
        "condition": "isWorkspaceSettings",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "workspaceId",
                "variableName": "id"
              }
            ],
            "kind": "FragmentSpread",
            "name": "WorkspaceSettings"
          }
        ]
      },
      {
        "condition": "isPersonalSettings",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "PersonalSettings"
          }
        ]
      },
      {
        "condition": "isFieldSettings",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "tql",
                "variableName": "tql"
              },
              (v6/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "FieldSettingsView"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "SettingsViewQuery",
    "selections": [
      {
        "condition": "isWorkspaceSettings",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id"
              }
            ],
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "concreteType": "UserWorkspacePermissions",
                "kind": "LinkedField",
                "name": "userWorkspacePermissions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "admin"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "organisationId"
              },
              {
                "kind": "ScalarField",
                "name": "goalScoringMode"
              },
              {
                "kind": "ScalarField",
                "name": "timezone"
              },
              {
                "kind": "ScalarField",
                "name": "keyPrefix"
              },
              (v8/*: any*/)
            ]
          },
          {
            "concreteType": "RecordCount",
            "kind": "LinkedField",
            "name": "workspaceCount",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "recordCount"
              }
            ]
          },
          {
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "alias": "optIn",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "keys": [
                        "NAV_REFRESH_ADMIN_OPT_IN"
                      ]
                    }
                  },
                  (v9/*: any*/)
                ],
                "concreteType": "OnboardingConnection",
                "kind": "LinkedField",
                "name": "onboarding",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": "onboarding(filter:{\"keys\":[\"NAV_REFRESH_ADMIN_OPT_IN\"]},first:1)"
              },
              (v8/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "isPersonalSettings",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "aaid"
              },
              {
                "concreteType": "TeamResponseBody",
                "kind": "LinkedField",
                "name": "slackTeams",
                "plural": true,
                "selections": (v15/*: any*/)
              },
              {
                "concreteType": "TenantResponseBody",
                "kind": "LinkedField",
                "name": "msteamsTenants",
                "plural": true,
                "selections": (v15/*: any*/)
              },
              {
                "concreteType": "UserPII",
                "kind": "LinkedField",
                "name": "pii",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "email"
                  }
                ]
              },
              {
                "concreteType": "UserPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "emailReminderEnabled"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "slackReminderEnabled"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "msteamsReminderEnabled"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "emailSummaryEnabled"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "slackSummaryEnabled"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "msteamsSummaryEnabled"
                  },
                  (v8/*: any*/)
                ]
              },
              {
                "args": (v16/*: any*/),
                "concreteType": "OnboardingConnection",
                "kind": "LinkedField",
                "name": "onboarding",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "OnboardingEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Onboarding",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v8/*: any*/),
                          (v14/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  },
                  (v12/*: any*/)
                ],
                "storageKey": "onboarding(first:200)"
              },
              {
                "args": (v16/*: any*/),
                "handle": "connection",
                "key": "OnboardingSettingsQuery__onboarding",
                "kind": "LinkedHandle",
                "name": "onboarding"
              },
              {
                "alias": "optOut",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "keys": [
                        "NAV_REFRESH_OPT_OUT"
                      ]
                    }
                  },
                  (v9/*: any*/)
                ],
                "concreteType": "OnboardingConnection",
                "kind": "LinkedField",
                "name": "onboarding",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": "onboarding(filter:{\"keys\":[\"NAV_REFRESH_OPT_OUT\"]},first:1)"
              },
              (v8/*: any*/)
            ]
          }
        ]
      },
      {
        "condition": "isFieldSettings",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "q",
                "variableName": "tql"
              },
              (v6/*: any*/)
            ],
            "concreteType": "CustomFieldDefinitionConnection",
            "kind": "LinkedField",
            "name": "customFieldDefinitionTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "CustomFieldDefinitionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v14/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  (v17/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "description"
                                  }
                                ],
                                "type": "CustomFieldDefinitionNode",
                                "abstractKey": "__isCustomFieldDefinitionNode"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v18/*: any*/)
                                ],
                                "type": "UserCustomFieldDefinition"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v18/*: any*/),
                                  {
                                    "concreteType": "CustomFieldTextAllowedValueConnection",
                                    "kind": "LinkedField",
                                    "name": "allowedValues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "CustomFieldTextAllowedValueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "CustomFieldTextAllowedValueNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v8/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "value"
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "type": "TextSelectCustomFieldDefinition"
                              },
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isNode"
                              }
                            ],
                            "type": "CustomFieldDefinition",
                            "abstractKey": "__isCustomFieldDefinition"
                          }
                        ],
                        "type": "CustomFieldDefinitionNode",
                        "abstractKey": "__isCustomFieldDefinitionNode"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": "connectionId",
                    "kind": "ScalarField",
                    "name": "__id"
                  },
                  (v11/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "SupportedCustomFields",
            "kind": "LinkedField",
            "name": "supportedCustomFields",
            "plural": false,
            "selections": [
              {
                "concreteType": "CustomFieldTypeConfig",
                "kind": "LinkedField",
                "name": "typesConfig",
                "plural": true,
                "selections": [
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "canSetAllowedValues"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "entities"
              }
            ]
          },
          {
            "alias": "totalCustomFieldDefinitions",
            "args": [
              {
                "kind": "Literal",
                "name": "q",
                "value": ""
              },
              (v6/*: any*/)
            ],
            "concreteType": "CustomFieldDefinitionConnection",
            "kind": "LinkedField",
            "name": "customFieldDefinitionTql",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "count"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "a002a666c53b33be683d28edd1d25b89",
    "id": null,
    "metadata": {},
    "name": "SettingsViewQuery",
    "operationKind": "query",
    "text": "query SettingsViewQuery(\n  $id: ID!\n  $isPersonalSettings: Boolean!\n  $isWorkspaceSettings: Boolean!\n  $isFieldSettings: Boolean!\n  $workspaceUuid: UUID!\n  $tql: String!\n) {\n  ...WorkspaceSettings_2T50cy @include(if: $isWorkspaceSettings)\n  ...PersonalSettings @include(if: $isPersonalSettings)\n  ...FieldSettingsView_Z4eZt @include(if: $isFieldSettings)\n}\n\nfragment ConnectionInfo_data on User {\n  aaid\n  slackTeams {\n    name\n  }\n  msteamsTenants {\n    name\n  }\n}\n\nfragment CreateCustomFieldForm on SupportedCustomFields {\n  ...CustomFieldForm\n}\n\nfragment CustomFieldBaseRow on CustomFieldDefinition {\n  __isCustomFieldDefinition: __typename\n  __typename\n  ... on CustomFieldDefinitionNode {\n    __isCustomFieldDefinitionNode: __typename\n    id\n    name\n    type\n    description\n  }\n  ... on UserCustomFieldDefinition {\n    canSetMultipleValues\n  }\n  ... on TextSelectCustomFieldDefinition {\n    canSetMultipleValues\n    allowedValues {\n      edges {\n        node {\n          id\n          value\n        }\n      }\n    }\n  }\n}\n\nfragment CustomFieldDefinitionRow on CustomFieldDefinition {\n  __isCustomFieldDefinition: __typename\n  ... on CustomFieldDefinitionNode {\n    __isCustomFieldDefinitionNode: __typename\n    id\n  }\n  ...CustomFieldBaseRow\n  ... on Node {\n    __isNode: __typename\n    id\n  }\n}\n\nfragment CustomFieldForm on SupportedCustomFields {\n  typesConfig {\n    type\n    canSetMultipleValues\n    canSetAllowedValues\n  }\n}\n\nfragment CustomFieldList on CustomFieldDefinitionConnection {\n  edges {\n    node {\n      __typename\n      ... on CustomFieldDefinitionNode {\n        __isCustomFieldDefinitionNode: __typename\n        id\n        ...CustomFieldDefinitionRow\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment DomainsAndGroups on Workspace {\n  organisationId\n}\n\nfragment EditCustomFieldForm on SupportedCustomFields {\n  ...CustomFieldForm\n}\n\nfragment FieldSettingsView_Z4eZt on Query {\n  ...TabPanelBody_Z4eZt\n  totalCustomFieldDefinitions: customFieldDefinitionTql(q: \"\", workspaceUuid: $workspaceUuid) {\n    count\n  }\n  supportedCustomFields {\n    entities\n  }\n}\n\nfragment GoalScoringModeSetting on Workspace {\n  goalScoringMode\n}\n\nfragment IntegrationSettings_data on User {\n  aaid\n  slackTeams {\n    __typename\n  }\n  msteamsTenants {\n    __typename\n  }\n  pii {\n    email\n  }\n  ...NotificationSettingsForm_data\n}\n\nfragment NavRefreshOptOut on User {\n  optOut: onboarding(first: 1, filter: {keys: [NAV_REFRESH_OPT_OUT]}) {\n    edges {\n      node {\n        key\n        id\n      }\n    }\n  }\n}\n\nfragment NavRefreshSiteOptIn on Query {\n  currentUser {\n    optIn: onboarding(first: 1, filter: {keys: [NAV_REFRESH_ADMIN_OPT_IN]}) {\n      edges {\n        node {\n          key\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment NotificationSettingsForm_data on User {\n  preferences {\n    emailReminderEnabled\n    slackReminderEnabled\n    msteamsReminderEnabled\n    emailSummaryEnabled\n    slackSummaryEnabled\n    msteamsSummaryEnabled\n    id\n  }\n  ...ConnectionInfo_data\n  slackTeams {\n    name\n  }\n  msteamsTenants {\n    name\n  }\n}\n\nfragment OnboardingSettings_onboarding on User {\n  onboarding(first: 200) {\n    edges {\n      node {\n        key\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment PersonalSettings on Query {\n  currentUser {\n    ...IntegrationSettings_data\n    ...OnboardingSettings_onboarding\n    ...NavRefreshOptOut\n    id\n  }\n}\n\nfragment TabPanelBody_Z4eZt on Query {\n  customFieldDefinitionTql(q: $tql, workspaceUuid: $workspaceUuid) {\n    edges {\n      __typename\n    }\n    ...CustomFieldList\n  }\n  supportedCustomFields {\n    ...CreateCustomFieldForm\n    ...EditCustomFieldForm\n  }\n}\n\nfragment WorkspaceSettings_2T50cy on Query {\n  workspace(id: $id) {\n    name\n    userWorkspacePermissions {\n      admin\n    }\n    ...DomainsAndGroups\n    ...GoalScoringModeSetting\n    ...WorkspaceTimezone\n    ...WorkspaceShortName\n    id\n  }\n  workspaceCount {\n    recordCount\n  }\n  ...NavRefreshSiteOptIn\n}\n\nfragment WorkspaceShortName on Workspace {\n  keyPrefix\n}\n\nfragment WorkspaceTimezone on Workspace {\n  timezone\n}\n"
  }
};
})();

(node as any).hash = "2063003723d94bcfa8c70a370ea55b93";

export default node;
